import React from 'react';
import Flight from '../../../../Common/Partials/Flight';

const FlightsTab = (props) => (
  <div>
    <Flight {...props} />
  </div>
);

export default FlightsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/Partials/FlightsTab.tsx